// const serviceCards = [
//   {
//     id: 1,
//     title: "Clarity in Every Trade",
//     description:
//       " We believe understanding the market is the first step to mastering it. Our platform is built to make every trade clear and every decision informed.",
//   },
//   {
//     id: 2,
//     title: "Trust Through Transparency",
//     description:
//       "Integrity is at the heart of everything we do, from our pricing to our policies. We strive to earn and maintain your trust through every interaction.",
//   },
//   {
//     id: 3,
//     title: "Empowerment Through Education",
//     description:
//       "We’re passionate about helping beginners transform into confident traders. Learning is not just an option at The Pips, it’s our foundation.",
//   },
//   {
//     id: 4,
//     title: "Innovation That Inspires",
//     description:
//       "We embrace technology that makes trading smarter, safer, and more intuitive, ensuring every trader has the tools to succeed.",
//   },
//   {
//     id: 5,
//     title: "Community That Connects",
//     description:
//       "Behind every trade is a human story. We’re proud to build a community where support, growth, and collaboration thrive.",
//   },
//   {
//     id: 6,
//     title: "Excellence Through Experience",
//     description:
//       "We continuously refine our platform and services through real market insights and user feedback, ensuring that every trader, beginner or expert, experiences the highest standard of performance, reliability, and support.",
//   },
// ];
import TopicThree from "../stock-market-contents/TopicThree";

const StockMarketContentThree = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      {/* <TopicThree /> */}

      <div className="how__work__market">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Invest in Global Stocks the Smarter Way</h1>
            <p>
              At The Pips, we combine cutting-edge technology with deep market
              insight to give traders a seamless, data-driven, and transparent
              stock trading experience. Here’s what sets us apart:
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Unified Multi-Asset Platform</h4>
                </div>
                <p>
                  {/* Trade stocks, forex, crypto, and commodities all in one place.
                  The Pips’ all-in-one platform ensures a smooth trading flow
                  with powerful analytics and cross-market visibility. */}
                  Trade multiple markets seamlessly in one powerful platform.
                </p>
              </div>
            </div>

            {/* Email Inquiries */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Real-Time Insights & Analytics</h4>
                </div>
                <p>
                  {/* Get instant access to live prices, earnings data, and market
                  news directly from your trading dashboard, helping you stay
                  ahead of every opportunity. */}
                  Get instant market data and insights, all in one dashboard.
                </p>
              </div>
            </div>

            {/* Our Office */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  {/* <h4>Institutional-Grade Security & Transparency</h4> */}
                  <h4>Institutional-Grade Security</h4>
                </div>
                <p>
                  {/* Trade confidently knowing your funds and data are protected
                  with bank-grade encryption, compliant infrastructure, and
                  complete transparency on pricing and execution. */}
                  Enjoy secure trading with encrypted, transparent systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockMarketContentThree;
